import { useEffect, useState } from 'react';

/**
 * True when the viewport meets optional min width/height (CSS px, includes zoom).
 * `minHeight <= 0` skips the height constraint.
 */
export function useAppViewportMatch(minWidth: number, minHeight: number = 0): boolean {
  const widthPart = `(min-width: ${minWidth}px)`;
  const query = minHeight > 0 ? `${widthPart} and (min-height: ${minHeight}px)` : widthPart;

  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return true;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (): void => {
      setMatches(mql.matches);
    };
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
